import React, { useState, createContext } from 'react'
import "./setupBoard.scss"

import SetupChecklist from '../SetupChecklist'
import SetupDetails from '../SetupDetails'
import useAdminContainerHeight from 'hooks/useAdminContainerHeight/useAdminContainerHeight'
import { useQuery } from 'react-query'
import { fetchCustomProfileFields } from 'api/react-query/services/CommunityService/queryFns'

interface ISetupBoard {
    groupData: any
    refreshGroupInformations: () => void
    courseExists: boolean
    OnboardingEmailsSet: boolean
    isPopup?: boolean
    libraryContentExists?: boolean
    workflowExists?: boolean
    landingPagesExists?: boolean
}

export const SetupBoardContext = createContext<any>({});

const SetupBoard: React.FC<ISetupBoard> = ({
    refreshGroupInformations, groupData, courseExists, OnboardingEmailsSet, isPopup, libraryContentExists, workflowExists, landingPagesExists
}) => {
    const [selectedComp, setSelectedComp] = useState<number>(0)
    const tabWrapElHeight = useAdminContainerHeight();

    // Custom hook to get community fields
    const useCommunityFields = () => {
        return useQuery(
            ['communityFields', groupData && groupData.id], // queryKey with unique identifier
            () => fetchCustomProfileFields(groupData && groupData.id), // queryFn
            {
                enabled: groupData && !!groupData.id, // Only run the query if groupData.id exists
            }
        );
    };

    const { data } = useCommunityFields();
    // Usage in a component
    function membershipQuestionsConfigured(passeGroupData: any) {
        return data && data.length > 0;
    }

    return (
        <SetupBoardContext.Provider value={{
            refreshGroupInformations, courseExists, OnboardingEmailsSet,
            membershipQuestionsConfigured, isPopup, selectedComp, setSelectedComp, libraryContentExists, workflowExists, landingPagesExists
        }}>
            <div
                style={{ minHeight: `${tabWrapElHeight - 210}px` }}
                className={`setup-body-wrapper ${isPopup ? 'popup' : ''}`}
            >
                {
                    !isPopup &&
                <div className='setup-checklist'>
                    <SetupChecklist selectComp={setSelectedComp} groupData={groupData} />
                </div>
                }
                <div className='line-between' />
                <div className='setup-details'>
                    <SetupDetails selected={selectedComp} groupData={groupData} />
                </div>
            </div>
        </SetupBoardContext.Provider>
    )
}

export default SetupBoard